@if (
  {
    subscription: getFilteredSubscriptions(),
    ssSingUp: getFilteredSubscriptionSignups(),
    tabCounts: getSubscriptionTabCounts(),
  };
  as $
) {
  @if (showsubscriptionDetails) {
    <div
      (click)="BacktoAllSubscriptions()"
      class="inline-flex cursor-pointer pl-2 pr-3 mr-3 py-3 md:align-items-center border-right-1 border-300"
    >
      <span class="flex align-items-center text-primary text-sm font-bold">
        <i class="fa fa-angle-left mr-2"></i>
        <span>{{ 'SUBSCRIPTIONS.BACK' | translate }}</span>
      </span>
    </div>
  }
  @if (showsubscriptionDetails) {
    <strong>{{ 'SUBSCRIPTIONS.SUBSCRIPTION-DETAILS' | translate }}</strong>
  }
  <!-- Create New Subscription -->

  <!-- Tabs and Button -->
  @if (!showSkeleton && !showsubscriptionDetails) {
    <div class="flex align-items-center justify-content-between p-3">
      <!-- Tabs -->
      <ul class="m-0 p-0 list-none flex text-sm border-round">
        <li>
          <a
            pRipple
            class="cursor-pointer block px-4 py-2 text-white transition-all transition-duration-150 border-round-left text-center"
            [ngClass]="{
              'bg-primary': selectedFilter === 'active',
              'bg-gray-600': selectedFilter !== 'active',
            }"
            (click)="selectedFilter = 'active'"
          >
            {{ 'SUBSCRIPTIONS.FILTER.ACTIVE' | translate }} ({{
              $.tabCounts.activeCount
            }})
          </a>
        </li>
        <li>
          <a
            pRipple
            class="cursor-pointer block px-4 py-2 text-white transition-all transition-duration-150 text-center border-right-1 border-white"
            [ngClass]="{
              'bg-primary': selectedFilter === 'expired',
              'bg-gray-600': selectedFilter !== 'expired',
            }"
            (click)="selectedFilter = 'expired'"
          >
            {{ 'SUBSCRIPTIONS.FILTER.EXPIRED' | translate }} ({{
              $.tabCounts.expiredCount
            }})
          </a>
        </li>
        <!-- <li>
                <a pRipple
                    class="cursor-pointer block px-4 py-2 text-white transition-all transition-duration-150 text-center border-round-right border-right-1 border-white"
                    [ngClass]="{'bg-primary': selectedFilter === 'in-progress', 'bg-gray-600': selectedFilter !== 'in-progress'}" (click)="selectedFilter = 'in-progress'">
                    {{'SUBSCRIPTIONS.FILTER.IN_PROGRESS' | translate}} ({{inProgressSubscriptionsCount}})
                </a>
            </li> -->
      </ul>
      <!-- Tabs -->

      <!-- Button -->
      <div
        [routerLink]="['/pos/pos-addon-charges/' + clientId()]"
        (click)="closeProfileTab();
        "
      >
        <p-button icon="fa fa-plus" styleClass="md:hidden" />
        <p-button
          icon="fa fa-plus"
          label="{{ 'SUBSCRIPTIONS.SUBSCRIPTIONS-ADDON' | translate }}"
          styleClass="hidden md:inline-block text-sm"
        />
      </div>
      <!-- Button -->
    </div>
  }
  <!-- Tabs and Button -->

  <!-- Tabs and Button Skeleton -->
  @if (showSkeleton) {
    <div class="flex align-items-center justify-content-between px-3">
      <!-- Tabs -->
      @if (showSkeleton) {
        <div class="m-0 list-none flex text-sm border-round">
          <p-skeleton height="2rem" width="4.5rem" />
          <p-skeleton height="2rem" width="4.5rem" styleClass="mx-2" />
          <p-skeleton height="2rem" width="4.5rem" />
        </div>
      }
      <!-- Tabs -->

      <!-- Button -->
      <div>
        <p-skeleton width="2rem" height="2rem" styleClass="md:hidden" />
        <p-skeleton width="9rem" height="2rem" styleClass="hidden md:block" />
      </div>
      <!-- Button -->
    </div>
  }
  <!-- Tabs and Button Skeleton -->

  <!-- Cards Wrapper -->
  @if (
    ($.subscription && $.subscription.length > 0) ||
    ($.ssSingUp && $.ssSingUp.length > 0) ||
    (showSkeleton$ | async)
  ) {
    <div class="mx-3">
      @if (!showsubscriptionDetails) {
        <div>
          @for (ss of $.subscription; track ss.id) {
            <!-- Paid In Full Card -->
            <div
              class="surface-0 border-1 border-300 border-round text-sm mt-3"
              [ngClass]="{
                'border-primary border-left-3':
                  ss.status.toLowerCase() === 'active',
              }"
            >
              <!-- Top Block -->
              <div
                class="cursor-pointer px-2 md:px-3 pt-2 md:pt-3"
                (click)="goToSubscriptionDetails(ss); $event.stopPropagation()"
              >
                <div class="flex align-items-center mb-3 text-xxs font-bold">
                  @if (isNotRenewingStatus(ss.status)) {
                    <span
                      class="surface-300 px-2 py-1 border-round text-600 border-1 border-600 text-xs uppercase mr-2"
                    >
                      {{ 'SUBSCRIPTIONS.NOT_RENEWING' | translate }}
                    </span>
                  }
                  <span
                    class="surface-200 text-600 px-2 py-1 border-round mr-3 uppercase"
                    >{{
                      'POS.PLANTYPE.' +
                        ss.subscription_category.toString().toUpperCase()
                        | translate
                    }}</span
                  >
                  @if (!isNotRenewingStatus(ss.status)) {
                    <span
                      class="inline-flex align-items-center text-600 uppercase"
                    >
                      <i
                        class="fa fa-circle {{
                          subscriptionStatusTextColor(ss.status)
                        }} mr-1"
                      ></i
                      >{{ 'SUBSCRIPTIONS.STATUS.' + ss.status | translate }}
                    </span>
                  }
                  @if (
                    isRecurring(ss.subscription_category) &&
                    isBillingStopped(ss)
                  ) {
                    <span
                      class="inline-flex align-items-center px-2 py-1 border-round text-xxs font-bold uppercase ml-2 mr-2 bg-red-500 text-white white-space-nowrap"
                      aria-label="billing-status-stopped"
                    >
                      <i class="fa fa-exclamation-circle mr-1"></i>
                      {{
                        'SUBSCRIPTIONS.BILLING_STOPPED_BADGE' | translate
                      }}
                    </span>
                  }
                  @if (isNotRenewingStatus(ss.status)) {
                    <span
                      class="inline-flex align-items-center text-600 uppercase"
                    >
                      <i
                        class="fa fa-circle {{
                          subscriptionStatusTextColor(ss.status)
                        }} mr-1"
                      ></i
                      >{{ ss.state | titlecase }}
                    </span>
                  }
                  <!-- See What's Pending Tag -->
                  @if (isPendingForMandatoryAction(ss.status)) {
                    <span
                      class="bg-orange-100 text-orange-600 px-2 py-1 border-round text-xs cursor-pointer ml-2 hover:bg-orange-200 transition-colors"
                      (click)="showPendingActionsDetails(ss, $event)"
                      aria-label="see-whats-pending-tag"
                    >
                      {{ 'SUBSCRIPTIONS.SEE_WHATS_PENDING' | translate }}
                    </span>
                  }
                  @if (isStatusOverridden(ss)) {
                    <span
                      class="bg-orange-100 text-orange-600 px-2 py-1 border-round text-xs ml-2 white-space-nowrap uppercase font-bold"
                      [pTooltip]="'SUBSCRIPTIONS.MANUAL_OVERRIDE_TOOLTIP' | translate"
                      tooltipPosition="top"
                      aria-label="manual-override-badge"
                    >
                      {{ 'SUBSCRIPTIONS.MANUAL_OVERRIDE_BADGE' | translate }}
                    </span>
                  }
                  @if (getTrackMode(ss) !== '') {
                    <span
                      class="bg-blue-50 p-1 border-round text-600 white-space-nowrap text-xs flex align-items-center justify-content-center ml-2"
                    >
                      {{ getTrackMode(ss) }}
                    </span>
                  }
                </div>

                @if (isUpgraded(ss)) {
                  <div class="mb-2">
                    @if (
                      getFromUpgradeSubs(ss.upgrade_from_clt_subs_id);
                      as data
                    ) {
                      <p-message
                        severity="info"
                        styleClass="relative"
                        aria-label="subscription-upgrade-info-message"
                      >
                        <div class="flex align-items-center w-full">
                          <i class="fa fa-info-circle text-xl"></i>
                          <div
                            class="ml-3 text-sm"
                            (click)="
                              goToSubscriptionDetails(data);
                              $event.stopPropagation()
                            "
                            [innerHTML]="
                              'SUBSCRIPTIONS.SUBS_UPGRADE_FROM_NAME'
                                | translate
                                  : { name: data.name_primary_language }
                            "
                          ></div>
                        </div>
                      </p-message>
                    }
                  </div>
                }

                @if (isTransferred(ss)) {
                  <div class="mb-2">
                    <p-message
                      severity="warn"
                      styleClass="relative"
                      aria-label="subscription-transfer-info-message"
                    >
                      <div class="flex align-items-center w-full">
                        <i class="fa fa-exchange-alt text-xl"></i>
                        <div class="ml-3 text-sm">
                          @if (isTransferredFrom(ss)) {
                            @if (isLocationTransfer(ss)) {
                              <span
                                [innerHTML]="
                                  'SUBSCRIPTIONS.SUBS_TRANSFER_FROM_CLUB'
                                    | translate
                                      : { name: getTransferFromName(ss) }
                                "
                              ></span>
                            } @else {
                              <span
                                [innerHTML]="
                                  'SUBSCRIPTIONS.SUBS_TRANSFER_FROM_CLIENT'
                                    | translate
                                      : {
                                          name: getTransferFromName(ss),
                                          id: getTransferFromId(ss),
                                        }
                                "
                              ></span>
                            }
                          }
                          @if (isTransferredTo(ss)) {
                            @if (isLocationTransfer(ss)) {
                              <span
                                [innerHTML]="
                                  'SUBSCRIPTIONS.SUBS_TRANSFER_TO_CLUB'
                                    | translate: { name: getTransferToName(ss) }
                                "
                              ></span>
                            } @else {
                              <span
                                [innerHTML]="
                                  'SUBSCRIPTIONS.SUBS_TRANSFER_TO_CLIENT'
                                    | translate
                                      : {
                                          name: getTransferToName(ss),
                                          id: getTransferToId(ss),
                                        }
                                "
                              ></span>
                            }
                          }
                        </div>
                      </div>
                    </p-message>
                  </div>
                }

                <!-- Parent/Child Subscription Banner -->
                @if (isParentSubscription(ss) || isChildSubscription(ss)) {
                  <div class="mb-2">
                    <p-message
                      [severity]="isParentSubscription(ss) ? 'success' : 'info'"
                      styleClass="relative"
                      aria-label="subscription-family-info-message"
                    >
                      <div class="flex align-items-center w-full">
                        <i class="fa fa-users text-xl"></i>
                        <div class="ml-3 text-sm">
                          @if (isParentSubscription(ss)) {
                            <span>{{
                              'SUBSCRIPTIONS.PARENT_SUBSCRIPTION_INFO'
                                | translate
                            }}</span>
                          }
                          @if (isChildSubscription(ss)) {
                            <span>{{
                              'SUBSCRIPTIONS.CHILD_SUBSCRIPTION_INFO'
                                | translate
                            }}</span>
                          }
                        </div>
                      </div>
                    </p-message>
                  </div>
                }

                <div
                  class="mb-1 flex align-items-center justify-content-between"
                >
                  <h3 class="mb-0 font-bold text-sm md:text-base">
                    {{
                      ss.name_primary_language || ss.name_secondary_language
                        | titlecase
                    }}
                  </h3>
                </div>
                @if (!isRecurring(ss.subscription_category)) {
                  <div class="mb-2 text-xs text-600">
                    {{ ss.description_primary_language }}
                  </div>
                }
                @if (isRecurring(ss.subscription_category)) {
                  <div
                    class="mb-2 text-xs text-600"
                    [innerHTML]="getRecurringServicesText(ss)"
                  ></div>
                }
                @if (!isRecurring(ss.subscription_category)) {
                  <div
                    class="mb-2 text-xs text-600"
                    [innerHTML]="getNonRecurringServicesText(ss)"
                  ></div>
                }
                <div class="flex align-items-center">
                  <span class="flex align-items-center text-xs">
                    <i class="fa fa-map-marker-alt text-lg text-600 mr-1"></i>
                    @if (getTenant(ss.tenant_id); as tenant) {
                      <span>{{
                        tenant.name_primary_language ||
                          tenant.name_secondary_language
                      }}</span>
                    }
                  </span>
                  @if (isPresalePurchased(ss)) {
                    <p-tag
                      styleClass="text-xxs font-normal uppercase bg-purple-500 font-bold white-space-nowrap ml-2"
                    >
                      {{ 'TENANT.PRESALE' | translate }}
                    </p-tag>
                  }
                </div>
                <hr
                  class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-2 mb-0"
                />
              </div>
              <!-- Top Block -->

              <!-- Bottom Block -->
              <div
                class="flex align-items-center justify-content-between py-2 px-3"
              >
                <!-- Date -->
                <div
                  class="flex align-items-center text-600 mr-2 md:mr-4 text-xs"
                >
                  <div class="flex mr-3 md:mr-5">
                    <i class="fa fa-calendar-days mr-2"></i>
                    <span
                      >{{ 'SUBSCRIPTIONS.START-DATE' | translate }}:
                      {{ ss.start_date | datetimeformat: 'mediumDate' }}</span
                    >
                  </div>
                  @if (isRecurring(ss.subscription_category)) {
                    <div class="flex">
                      <i class="fa fa-calendar-days mr-2"></i>
                      <span
                        >{{ 'SUBSCRIPTIONS.NEXT-BILLING-DATE' | translate }}:
                        <span class="block md:inline">{{
                          ss.next_charge_date | datetimeformat: 'mediumDate'
                        }}</span></span
                      >
                    </div>
                  }
                  @if (!isRecurring(ss.subscription_category)) {
                    <div class="flex mr-3 md:mr-5">
                      <i class="fa fa-calendar-days mr-2"></i>
                      <span
                        >{{ 'SUBSCRIPTIONS.END_DATE' | translate }}:
                        <span class="block md:inline">{{
                          ss.end_date | datetimeformat: 'mediumDate'
                        }}</span></span
                      >
                    </div>
                  }
                  @if (showSignUplink && showResendLink(ss)) {
                    <div class="flex mr-3 md:mr-5">
                      <i class="fa fa-paperclip mr-2"></i>
                      <div
                        target="_blank"
                        class="text-primary flex align-items-center cursor-pointer text-xs"
                        (click)="showLinkDetails.toggle($event)"
                      >
                        <span>{{
                          'SUBSCRIPTIONS.SIGNUP_LINK' | translate
                        }}</span
                        ><i class="fa fa-angle-down ml-2"></i>
                      </div>
                      <p-popover
                        #showLinkDetails
                        styleClass="overflow-hidden text-sm"
                      >
                        <ng-template #content>
                          @if (getSignupBySubscriptionId(ss.id); as signup) {
                            <ul class="list-none p-0 -my-3">
                              <li
                                class="flex align-items-center border-bottom-1 border-300 py-2"
                              >
                                <a
                                  class="text-900 w-12rem overflow-hidden text-overflow-ellipsis white-space-nowrap"
                                  [href]="signup.short_link"
                                  target="_blank"
                                >
                                  {{ truncatedText(signup.short_link) }}
                                </a>
                                <i
                                  class="fa fa-copy ml-3 cursor-pointer"
                                  (click)="copyToClipboard(signup.short_link)"
                                ></i>
                              </li>
                              <li
                                class="cursor-pointer py-2"
                                (click)="
                                  showQRCode = true;
                                  qrCodeLink = signup.short_link
                                "
                              >
                                {{ 'SUBSCRIPTIONS.VIEW_QR_CODE' | translate }}
                              </li>
                            </ul>
                          }
                        </ng-template>
                      </p-popover>
                    </div>
                  }
                  @if (showResendLink(ss)) {
                    <div class="flex mr-3 md:mr-5">
                      <i class="fa fa-paperclip mr-2"></i>
                      <div
                        target="_blank"
                        class="text-primary flex align-items-center cursor-pointer text-xs"
                        (click)="showResendLink.toggle($event)"
                      >
                        <span>{{
                          'SUBSCRIPTIONS.RESEND_LINK' | translate
                        }}</span
                        ><i class="fa fa-angle-down ml-2"></i>
                      </div>
                      <p-popover
                        #showResendLink
                        styleClass="overflow-hidden text-sm"
                      >
                        <ng-template #content>
                          <ul class="list-none p-0 -my-3">
                            <li
                              class="cursor-pointer py-2"
                              (click)="resendLinkForSubscription(ss, 'Email')"
                            >
                              {{ 'SUBSCRIPTIONS.SEND_EMAIL_LINK' | translate }}
                            </li>
                            <li
                              class="cursor-pointer py-2"
                              (click)="
                                resendLinkForSubscription(ss, 'WhatsApp')
                              "
                            >
                              {{
                                'SUBSCRIPTIONS.SEND_WHATSAPP_LINK' | translate
                              }}
                            </li>
                            <li
                              class="cursor-pointer py-2"
                              (click)="
                                resendLinkForSubscription(
                                  ss,
                                  'Push'
                                )
                              "
                            >
                              {{
                                'SUBSCRIPTIONS.SEND_PUSH_NOTIFICATION_LINK'
                                  | translate
                              }}
                            </li>
                          </ul>
                        </ng-template>
                      </p-popover>
                    </div>
                  }
                </div>
                <!-- Date -->

                <!-- Actions -->
                <div class="relative">
                  @if (!showSkeleton) {
                    <subscription-action-list
                      [class]=""
                      [clientId]="clientId()"
                      [tenantId]="tenantId"
                      [subscriptionId]="ss.id"
                      [subscription]="ss"
                      (closeAddonEvent)="closeAddonSidebar($event)"
                      [showFreeDiscount]="true"
                      [trackMode]="ss.track_mode"
                      (emitEvents)="emitEvents($event)"
                    />
                  }
                </div>
                <!-- Actions -->
              </div>
              <!-- Bottom Block -->
            </div>
            <!-- Paid In Full Card -->
          }

          @for (ss of $.ssSingUp; track ss.id) {
            <div
              class="surface-0 border-1 border-300 border-round text-sm mt-3"
            >
              <!-- Top Block -->
              <div
                class="cursor-pointer px-2 md:px-3 pt-2 md:pt-3"
                (click)="
                  GetSubscriptionDetails(ss.client_subscription_id)
                    ? goToSubscriptionDetails(
                        GetSubscriptionDetails(ss.client_subscription_id)
                      )
                    : null
                "
              >
                <div class="flex align-items-center mb-3 text-xxs font-bold">
                  @if (
                    GetSubscriptionDetails(ss.client_subscription_id);
                    as details
                  ) {
                    <span
                      class="bg-blue-50 px-2 py-1 border-round text-primary border-1 border-primary text-xs mr-2 mb-2"
                    >
                      {{
                        'POS.PLANTYPE.' +
                          details.subscription_category.toString().toUpperCase()
                          | translate
                      }}
                    </span>
                  }
                  <span
                    class="inline-flex align-items-center text-600 uppercase"
                    ><i class="fa fa-circle text-yellow-500 mr-1"></i
                    >{{
                      'SUBSCRIPTIONS.SIGNUP_' + ss.final_status.toUpperCase()
                        | translate
                    }}</span
                  >
                </div>
                <div class="flex align-items-center justify-content-between">
                  <h4 class="mb-0">
                    {{ 'SUBSCRIPTIONS.SIGN_UP_PROGRESS' | translate }}
                  </h4>
                  <strong>{{ getSignupProgress(ss).value }}%</strong>
                </div>
                <p-progressBar
                  [value]="getSignupProgress(ss).value"
                  [showValue]="false"
                  [styleClass]="'my-3 ' + getSignupProgress(ss).status"
                  [style]="{ height: '6px' }"
                />
                <div class="text-sm mb-2">{{ getSignupProgress(ss).text }}</div>
                <h3 class="mb-0 font-bold text-sm md:text-base">
                  {{ ss.plan_primary_name || ss.plan_secondary_name }}
                </h3>
                <hr
                  class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-3 mb-0"
                />
              </div>
              <!-- Top Block -->

              <!-- Bottom Block -->
              <div
                class="flex align-items-center justify-content-between p-2 md:px-3"
              >
                <!-- Date -->
                <div class="flex align-items-center text-600 mr-4">
                  <div class="flex mr-3 md:mr-5">
                    <i class="fa fa-calendar-days mr-2"></i>
                    <span
                      >{{ 'SUBSCRIPTIONS.SIGNUP_LINK_EXPIRY' | translate }}:
                      <span class="block md:inline">{{
                        ss.link_expiry_date | datetimeformat: 'mediumDate'
                      }}</span></span
                    >
                  </div>
                  @if (showSignUplink) {
                    <div class="flex align-items-center mr-3 md:mr-5">
                      <i class="fa fa-paperclip mr-2"></i>
                      <div
                        target="_blank"
                        class="text-primary flex align-items-center cursor-pointer text-xs"
                        (click)="showLinkDetails.toggle($event)"
                      >
                        <span>{{
                          'SUBSCRIPTIONS.SIGNUP_LINK' | translate
                        }}</span
                        ><i class="fa fa-angle-down ml-2"></i>
                      </div>
                      <p-popover
                        #showLinkDetails
                        styleClass="overflow-hidden text-sm"
                      >
                        <ng-template #content>
                          <ul class="list-none p-0 -my-3">
                            <li
                              class="flex align-items-center border-bottom-1 border-300 py-2"
                            >
                              <a
                                class="text-900 w-12rem overflow-hidden text-overflow-ellipsis white-space-nowrap"
                                [href]="ss.short_link"
                                target="_blank"
                              >
                                {{ truncatedText(ss.short_link) }}
                              </a>
                              <i
                                class="fa fa-copy ml-3"
                                (click)="copyToClipboard(ss.short_link)"
                              ></i>
                            </li>
                            <li
                              class="cursor-pointer py-2"
                              (click)="
                                showQRCode = true; qrCodeLink = ss.short_link
                              "
                            >
                              {{ 'SUBSCRIPTIONS.VIEW_QR_CODE' | translate }}
                            </li>
                          </ul>
                        </ng-template>
                      </p-popover>
                    </div>
                  }
                  <div class="flex align-items-center">
                    <i class="fa fa-paperclip mr-2"></i>
                    <div
                      target="_blank"
                      class="text-primary flex align-items-center cursor-pointer text-xs"
                      (click)="showResendLink.toggle($event)"
                    >
                      <span>{{ 'SUBSCRIPTIONS.RESEND_LINK' | translate }}</span
                      ><i class="fa fa-angle-down ml-2"></i>
                    </div>
                    <p-popover
                      #showResendLink
                      styleClass="overflow-hidden text-sm"
                    >
                      <ng-template #content>
                        <ul class="list-none p-0 -my-3">
                          <li
                            class="cursor-pointer py-2"
                            (click)="resendLink(ss, 'Email')"
                          >
                            {{ 'SUBSCRIPTIONS.SEND_EMAIL_LINK' | translate }}
                          </li>
                          <li
                            class="cursor-pointer py-2"
                            (click)="resendLink(ss, 'WhatsApp')"
                          >
                            {{ 'SUBSCRIPTIONS.SEND_WHATSAPP_LINK' | translate }}
                          </li>
                          <li
                            class="cursor-pointer py-2"
                            (click)="resendLink(ss, 'Push')"
                          >
                            {{
                              'SUBSCRIPTIONS.SEND_PUSH_NOTIFICATION_LINK'
                                | translate
                            }}
                          </li>
                        </ul>
                      </ng-template>
                    </p-popover>
                  </div>
                </div>
                <!-- Date -->

                <!-- Actions -->
                <div class="relative">
                  @if (
                    !showSkeleton &&
                    (ss.final_status === 'Open' ||
                      ss.final_status === 'Created')
                  ) {
                    <subscription-action-list
                      [class]=""
                      [clientId]="clientId()"
                      [tenantId]="tenantId"
                      [subscriptionId]="ss.client_subscription_id"
                      [signupId]="ss.id"
                      [signupData]="ss"
                      [subscription]="
                        GetSubscriptionDetails(ss.client_subscription_id)
                      "
                      (closeAddonEvent)="closeAddonSidebar($event)"
                      [showFreeDiscount]="true"
                      [trackMode]="ss.track_mode"
                      (emitEvents)="emitEvents($event)"
                    />
                  }
                </div>
                <!-- Actions -->
              </div>
              <!-- Bottom Block -->
            </div>
          }
        </div>
      } @else {
        <subscription-details
          [clientId]="clientId()"
          [subscriptionId]="subscriptionId"
          [subscription]="subscriptionDetails"
          [showFreeDiscount]="false"
          [allSubscription]="allSubscriptions$.getValue()"
          (emitEvents)="getEventData($event)"
        />
      }
    </div>
  } @else {
    <div
      class="surface-0 border-1 border-300 shadow-1 border-round text-sm p-5 text-center h-27rem m-3"
    >
      <p class="my-4 text-lg">
        {{ 'SUBSCRIPTIONS.NO_SUBSCRIPTION' | translate }}
      </p>
      <img
        src="/assets/img/empty-favorite-img.svg"
        [alt]="'SUBSCRIPTIONS.NO_SUBSCRIPTION' | translate"
      />
    </div>
  }
  <!-- Cards Wrapper -->

  <!-- Cards Wrapper Skeleton -->
  @if (showSkeleton) {
    <div class="mx-3">
      <!-- Card -->
      <div class="surface-0 border-1 border-300 border-round text-sm mt-3">
        <!-- Top Block -->
        <div class="cursor-pointer px-2 md:px-3 pt-2 md:pt-3">
          <div class="flex align-items-center mb-3 text-xxs font-bold">
            <p-skeleton width="4.5rem" height="1.25rem" styleClass="mr-3" />
            <p-skeleton width="4.5rem" height="1.25rem" />
          </div>
          <div class="mb-1 flex align-items-center justify-content-between">
            <p-skeleton width="10rem" height="1.1rem" />
            <div>
              <p-skeleton width="3.5rem" height="1.25rem" />
            </div>
          </div>
          <p-skeleton width="100%" height="1.1rem" styleClass="mb-3" />

          <span class="flex align-items-center">
            <p-skeleton
              width="1.4rem"
              height="1.4rem"
              shape="circle"
              styleClass="mr-1"
            />
            <p-skeleton width="3rem" height="1rem" />
          </span>

          <hr
            class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-3 mb-0"
          />
        </div>
        <!-- Top Block -->

        <!-- Bottom Block -->
        <div class="flex align-items-center justify-content-between py-2 px-3">
          <!-- Date -->
          <div class="flex align-items-center text-600 mr-4">
            <div class="flex align-items-center mr-3 md:mr-5">
              <p-skeleton
                width="1.4rem"
                height="1.4rem"
                shape="circle"
                styleClass="mr-2"
              />
              <p-skeleton width="4rem" height="1rem" />
            </div>
            <div class="flex align-items-center">
              <p-skeleton
                width="1.4rem"
                height="1.4rem"
                shape="circle"
                styleClass="mr-2"
              />
              <p-skeleton width="4rem" height="1rem" />
            </div>
          </div>
          <!-- Date -->

          <!-- Actions -->
          <p-skeleton width="6rem" height="2.15rem" />
          <!-- Actions -->
        </div>
        <!-- Bottom Block -->
      </div>
      <!-- Card -->

      <!-- Card -->
      <div class="surface-0 border-1 border-300 border-round text-sm mt-3">
        <!-- Top Block -->
        <div class="cursor-pointer px-2 md:px-3 pt-2 md:pt-3">
          <div class="flex align-items-center mb-3 text-xxs font-bold">
            <p-skeleton width="4.5rem" height="1.25rem" styleClass="mr-3" />
            <p-skeleton width="4.5rem" height="1.25rem" />
          </div>
          <div class="mb-1 flex align-items-center justify-content-between">
            <p-skeleton width="10rem" height="1.1rem" />
            <div>
              <p-skeleton width="3.5rem" height="1.25rem" />
            </div>
          </div>
          <p-skeleton width="100%" height="1.1rem" styleClass="mb-3" />

          <span class="flex align-items-center">
            <p-skeleton
              width="1.4rem"
              height="1.4rem"
              shape="circle"
              styleClass="mr-1"
            />
            <p-skeleton width="3rem" height="1rem" />
          </span>

          <hr
            class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-3 mb-0"
          />
        </div>
        <!-- Top Block -->

        <!-- Bottom Block -->
        <div class="flex align-items-center justify-content-between py-2 px-3">
          <!-- Date -->
          <div class="flex align-items-center text-600 mr-4">
            <div class="flex align-items-center mr-3 md:mr-5">
              <p-skeleton
                width="1.4rem"
                height="1.4rem"
                shape="circle"
                styleClass="mr-2"
              />
              <p-skeleton width="4rem" height="1rem" />
            </div>
            <div class="flex align-items-center">
              <p-skeleton
                width="1.4rem"
                height="1.4rem"
                shape="circle"
                styleClass="mr-2"
              />
              <p-skeleton width="4rem" height="1rem" />
            </div>
          </div>
          <!-- Date -->

          <!-- Actions -->
          <p-skeleton width="6rem" height="2.15rem" />
          <!-- Actions -->
        </div>
        <!-- Bottom Block -->
      </div>
      <!-- Card -->

      <!-- Card -->
      <div class="surface-0 border-1 border-300 border-round text-sm mt-3">
        <!-- Top Block -->
        <div class="cursor-pointer px-2 md:px-3 pt-2 md:pt-3">
          <div class="flex align-items-center mb-3 text-xxs font-bold">
            <p-skeleton width="4.5rem" height="1.25rem" styleClass="mr-3" />
            <p-skeleton width="4.5rem" height="1.25rem" />
          </div>
          <div class="mb-1 flex align-items-center justify-content-between">
            <p-skeleton width="10rem" height="1.1rem" />
            <div>
              <p-skeleton width="3.5rem" height="1.25rem" />
            </div>
          </div>
          <p-skeleton width="100%" height="1.1rem" styleClass="mb-3" />

          <span class="flex align-items-center">
            <p-skeleton
              width="1.4rem"
              height="1.4rem"
              shape="circle"
              styleClass="mr-1"
            />
            <p-skeleton width="3rem" height="1rem" />
          </span>

          <hr
            class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-3 mb-0"
          />
        </div>
        <!-- Top Block -->

        <!-- Bottom Block -->
        <div class="flex align-items-center justify-content-between py-2 px-3">
          <!-- Date -->
          <div class="flex align-items-center text-600 mr-4">
            <div class="flex align-items-center mr-3 md:mr-5">
              <p-skeleton
                width="1.4rem"
                height="1.4rem"
                shape="circle"
                styleClass="mr-2"
              />
              <p-skeleton width="4rem" height="1rem" />
            </div>
            <div class="flex align-items-center">
              <p-skeleton
                width="1.4rem"
                height="1.4rem"
                shape="circle"
                styleClass="mr-2"
              />
              <p-skeleton width="4rem" height="1rem" />
            </div>
          </div>
          <!-- Date -->

          <!-- Actions -->
          <p-skeleton width="6rem" height="2.15rem" />
          <!-- Actions -->
        </div>
        <!-- Bottom Block -->
      </div>
      <!-- Card -->
    </div>
  }
  <!-- Cards Wrapper Skeleton -->
  <!-- No Subscription -->
}

<p-dialog
  [visible]="voidSignUpPopup"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '500px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <form [formGroup]="VoidSubscriptionSignupForm">
      <div
        class="p-3 sticky w-full top-0 right-0 surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h4 class="text-base font-normal mb-0">
          {{ 'common.HEADERS.CONFIRM_VOID_SIGNUP' | translate }}
        </h4>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="voidSignUpPopup = false; voidSignUpBtnLoading = false"
        ></div>
        <!-- <span class="text-sm text-blue-600">{{ 'SUBSCRIPTIONS.ACTIVATE_INFO'  | translate }} </span> -->
      </div>
      <!-- Header -->

      <!-- Content -->
      <div class="surface-100 p-3">
        <div class="mb-3 -mt-3">
          <p-message
            severity="info"
            aria-label="subscription-void-info-message"
          >
            {{ 'SUBSCRIPTIONS.SIGNUP_VOID_INFO' | translate }}
          </p-message>
        </div>

        <label for="void_reasons" class="font-medium text-700 text-xs mb-2 block uppercase">{{
          'SUBSCRIPTIONS.REASON' | translate
        }}</label>
        <textarea
          pInputTextarea
          formControlName="void_reasons"
          class="text-sm w-full h-5rem"
        ></textarea>
        @if (
          ChangeReasonFormControl.touched && ChangeReasonFormControl.invalid
        ) {
          <app-error-msg
            [errors]="ChangeReasonFormControl.errors"
            [fieldLabel]="'SUBSCRIPTIONS.REASON' | translate"
          />
        }
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <div class="w-4"></div>
        <div class="w-8 text-right">
          <p-confirmpopup key="activatemembership" />
          <button
            pButton
            pRipple
            type="button"
            [label]="'common.BUTTONS.BTN_CONFIRM' | translate"
            class="p-button-primary text-sm"
            (click)="confirm($event)"
          ></button>
        </div>
      </div>
      <!-- Modal Footer -->
    </form>

    @if (showErrorPopup | async; as show_Popup) {
      <app-errors
        [visible]="show_Popup"
        (onHide)="closeDialog()"
        [errorData]="errorMessages"
        [error]="error"
        (hideErrorPopup)="HideErrorPopup($event)"
      />
    }
  </ng-template>
</p-dialog>

<!-- Show QR Code -->
<p-dialog
  [visible]="showQRCode"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '500px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div class="flex justify-content-end border-bottom-1 border-300 mb-3">
      <div
        class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mr-4 cursor-pointer"
        (click)="showQRCode = false"
      ></div>
    </div>
    <!-- Header -->

    <!-- Content -->
    <div class="py-5 px-7">
      <strong class="block font-bold text-center text-sm mb-4">{{
        'SUBSCRIPTIONS.SCAN_QR_CODE' | translate
      }}</strong>
      <qr-code
        [styleClass]="'w-full'"
        [value]="qrCodeLink"
        size="400"
        errorCorrectionLevel="H"
        centerImageSrc="undefined"
        centerImageSize="undefined"
        margin="4"
      />
    </div>
    <!-- Content -->
  </ng-template>
</p-dialog>
<!-- Show QR Code -->

@if (showBillingSidebar) {
  <billing
    [billedAtTenantId]="tenantId"
    [planSummarydata]="planSummarydataObject"
    [showPosBilling]="false"
    [showbilling]="true"
    closeOnEscape="false"
    (closeSidePopupMember)="HideBillingSummary()"
    (GoToClientSubscription)="GoToClientDetails($event)"
  />
}

<!-- Pending Actions Popup -->
<pending-actions-popup
  [visible]="showPendingActionsPopup"
  [pendingDetails]="selectedPendingDetails"
  [isAutopayEnabled]="selectedSubscriptionAutopay"
  (closePopup)="closePendingActionsPopup()"
/>
